/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useImperativeHandle, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { IconButton, makeStyles, Tooltip } from "@material-ui/core";
import { url } from "@/apis/apiSetup";
import * as localforage from "localforage";
import * as $ from "jquery";
// import { searchStyleRender } from "@/helpers/datatableSearchStyleRender";
// import { datatableErrorHandling } from "@/helpers/datatableErrorHandling";
import StatusChip from "@/components/commons/StatusChip";
import OSType from "@/components/commons/OSType";
import EditableIconForDatatable from "@/components/commons/EditableIconForDatatable";
import DeviceFunctionBlock from "@/components/device/DeviceFunctionBlock";
import HasPermission from "@/components/commons/HasPermission";
import DeviceOwners from "@/components/commons/DeviceOwners";
import { useTranslation } from "@/langs/useTranslation";
import DeviceTableColumnsManagerModal from "@/containers/GroupsDevices/DeviceTableColumnsManager/Modal";
import {
  getDeviceListFieldsApi, getDevicesListExcel,
  updateDeviceDetailApi,
  updateDeviceListFieldsApi,
  updateDeviceNameApi
} from "@/apis/apiCollection";
import iconSetting from "@/assets/svgs/setting.svg";
import { useLatest, useLocalStorageState, useUpdateEffect } from "ahooks";
import dayjs from "dayjs";
import TaskStatusBar, { TaskStatus } from "@/components/commons/TaskStatusBar";
import { downloadBlob, parseJSON } from "@/helpers/utils";
import DataTable from "@/components/DataTable";
import { ReactRender } from "../ReactRender";
import { EditRounded } from "@material-ui/icons";
import SearchInput from "../SearchInput";
import { errorHandling } from "@/helpers/errorHandling";
import ChipStatus from "../ChipStatus";
import {successHandling} from "@/helpers/successHandling";
import {toast} from "@/apis/request";

const useStyles = makeStyles(theme => ({
  setting: {
    cursor: "pointer",
    display: "block",
    // width: 30,
    textAlign: "center",
    "& img": {
      width: 16,
      height: 16
    }
  },
  mEditing: {
    display: "flex",
    "& > span": {
      display: "block",
      flex: 1,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  }
}));

const EditDesc = ({ deviceId, data, isDeviceName }) => {
  const [edit, setEdit] = useState(false);
  const descRef = useRef(data);
  const classes = useStyles();

  const handleEndEditDetail = async e => {
    const { value } = e.target;
    if (value !== descRef.current) {
      if (isDeviceName) {
        await updateDeviceNameApi({
          device_id: deviceId,
          device_name: value
        });
      } else {
        await updateDeviceDetailApi({
          deviceId,
          detail: value
        });
      }
    }
    descRef.current = value;
    setEdit(false);
  };

  return (
    <>
      {edit ? (
        <SearchInput
          icon={null}
          autoFocus
          defaultValue={descRef.current}
          onPressEnter={handleEndEditDetail}
          onBlur={handleEndEditDetail}
          style={{ width: 200 }}
        />
      ) : (
        <div className={classes.mEditing}>
          <Tooltip title={descRef.current} placement="top">
            <span>{descRef.current}</span>
          </Tooltip>
          <HasPermission
            permission={isDeviceName ? "" : "device_control_device_description"}
          >
            <IconButton
              aria-label="edit"
              size="small"
              onClick={() => setEdit(true)}
              style={{ marginLeft: 5 }}
            >
              <EditRounded fontSize="small" />
            </IconButton>
          </HasPermission>
        </div>
      )}
    </>
  );
};

const DevicesTable = React.forwardRef(
  (
    {
      className,
      style,
      showCheckAll,
      checkAllDisabled,
      getSearchParams,
      footer,
      children,
      onTagChange,
      onCheckAll,
      onLoaded,
      reloadTable
    },
    ref
  ) => {
    const tableRef = useRef(null);
    const paramsRef = useRef({});
    const queryParams = useRef({});
    const [columnsManagerModalOpen, setColumnsManagerModalOpen] =
      useState(false);
    const [options, setOptions] = useState({});
    const classes = useStyles();
    const history = useHistory();
    const customFieldsLoaded = useRef(false);

    const defaultPageInfo = {
      page: 0,
      length: 20
    };

    const defaultOrderInfo = [0, "asc"];

    const [lastGroupQueryPageInfo, setLastGroupQueryPageInfo] =
      useLocalStorageState("__lastGroupQueryPageInfo", {
        defaultValue: defaultPageInfo
      });

    const [lastGroupQueryOrderInfo, setLastGroupQueryOrderInfo] =
      useLocalStorageState("__lastGroupQueryOrderInfo", {
        defaultValue: defaultOrderInfo
      });

    const lastGroupQueryPageInfoRef = useLatest(lastGroupQueryPageInfo);
    const lastGroupQueryOrderInfoRef = useLatest(lastGroupQueryOrderInfo);

    const { t, userLanguage, langConf } = useTranslation("device");

    const handlePageLengthChange = pageInfo => {
      setLastGroupQueryPageInfo(pageInfo);
    };

    const toDetail = e => {
      e.preventDefault();
      const url = new URL(e.target.href);
      history.push(url.pathname);
    };

    const handleOrder = (settings, orderData) => {
      if (orderData && orderData.length) {
        setLastGroupQueryOrderInfo(orderData.map(item => [item.col, item.dir]));
      }
    };

    const createColumns = () => [
      {
        data: "device_key",
        title: `${t("category.deviceId")}`,
        visible: false,
        render: data => {
          return data ? data : "-";
        }
      },
      {
        data: "online_offline_status",
        className: "status",
        title: `${t("category.status")}`,
        searchable: false,
        createdCell: (td, data) => {
          ReactRender(<StatusChip statusLabel={data} useLabelAsClass />, td);
        }
      },
      {
        data: "serial_number",
        className: "serial_number",
        title: `${t("category.serialNumber")}`,
        searchable: true,
        visible: true,
        disabled: true,
        createdCell: (td, data, rowData) => {
          ReactRender(
            <HasPermission permission="Device Monitoring Detail">
              {yes =>
                yes ? (
                  <a
                    href={`/device-list/device-detail/${rowData.id}/${rowData.os_type}`}
                    onClick={toDetail}
                  >
                    {data}
                  </a>
                ) : (
                  data
                )
              }
            </HasPermission>,
            td
          );
        }
      },
      {
        data: "device_name",
        title: `${t({ defaultMessage: "设备名称" })}`,
        className: "editable-field",
        type: "string",
        searchable: true,
        createdCell: (td, data, rowData) => {
          ReactRender(
            <HasPermission permission="">
              <EditDesc deviceId={rowData.id} data={data} isDeviceName />
            </HasPermission>,
            td
          );
        }
      },
      {
        data: "detail",
        title: `${t({ defaultMessage: "描述" })}`,
        className: "editable-field",
        type: "string",
        searchable: true,
        createdCell: (td, data, rowData) => {
          ReactRender(<EditDesc deviceId={rowData.id} data={data} />, td);
        }
      },
      {
        data: "additional_type",
        title: t({ defaultMessage: "Nubis Cast" }),
        render: data => {
          if (data === undefined || data === null || data === "") return "-";
          return data === 1
            ? t({ defaultMessage: "开启" })
            : t({ defaultMessage: "关闭" });
        }
      },
      {
        data: "os_type",
        className: "os_type",
        title: `${t("category.os_type")}`,
        searchable: false,
        createdCell: (td, data) => {
          ReactRender(<OSType os={data} />, td);
        }
      },
      {
        data: "groups",
        name: "",
        title: `${t({ defaultMessage: "门店" })}`,
        className: "group",
        orderable: true,
        searchable: true,
        createdCell: (td, data) => {
          const groups = data.map((item, index) => {
            return (
              <span className="owner_name" key={index}>
                {item.name}
              </span>
            );
          });
          ReactRender(groups.length > 0 ? groups : "-", td);
        }
      },
      {
        data: "tags",
        title: `${t("category.tags")}`,
        className: "editable-field",
        //orderDataType: "dom-text",
        type: "string",
        searchable: true,
        // render: data => {
        //   return data.map(item => item.name).join(", ");
        // },
        createdCell: (td, data, rowData) => {
          ReactRender(
            <EditableIconForDatatable
              rowData={rowData}
              onChange={selectedTags => onTagChange(selectedTags, rowData)}
            />,
            td
          );
        }
      },
      {
        data: "kiosk_mode",
        title: t({ defaultMessage: "Kiosk模式" }),
        createdCell: (td, data, rowData) => {
          ReactRender(
            <>
              {data === undefined || data === null || data === "" ? (
                "-"
              ) : (
                <ChipStatus
                  type="info"
                  label={
                    data === 1
                      ? t({ defaultMessage: "开启" })
                      : t({ defaultMessage: "关闭" })
                  }
                />
              )}
            </>,
            td
          );
        }
      },
      {
        data: "power",
        className: "power",
        title: `${t("category.power")}`,
        searchable: false,
        orderable: false,
        createdCell: (td, data, rowData) => {
          ReactRender(
            <DeviceFunctionBlock
              reloadTableWithGroupId={reloadTable}
              rowData={rowData}
              os_type={rowData.os_type === "windows" ? "windows" : "android"}
              block="power"
              t={t}
            />,
            td
          );
        }
      },
      {
        data: "ora_version",
        className: "ora_version",
        title: `${t("category.oraVersion", {ora: langConf.deviceCenter?.oraText || "Ora"})}`,
        render: data => {
          return data ? data : "-";
        }
      },
      {
        data: "belong_to",
        title: `${t({ defaultMessage: "门店清单" })}`,
        render: data => {
          return data.join(", ");
        }
      },
      {
        data: "companies",
        name: "",
        className: "owners datatable-data-width-100",
        title: `${t("category.owners")}`,
        searchable: true,
        orderable: true,
        createdCell: (td, data, rowData) => {
          const companyArr = parseJSON(rowData.companies);
          const companyName = companyArr.map((item, index) => {
            return (
              <span className="owner_name" key={index}>
                {item.name}
              </span>
            );
          });
          ReactRender(
            companyArr && companyArr.length > 0 ? (
              <DeviceOwners owners={companyName} />
            ) : (
              "-"
            ),
            td
          );
        }
      },
      // {
      //   data: "security",
      //   className: "security",
      //   orderable: false,
      //   searchable: false,
      //   title: `${t("category.security")}`,
      //   createdCell: (td, data, rowData) => {
      //     ReactRender(
      //       <DeviceFunctionBlock
      //         reloadTableWithGroupId={() => initTable()}
      //         rowData={rowData}
      //         os_type={rowData.os_type === "windows" ? "windows" : "android"}
      //         block="security"
      //         t={t}
      //       />,
      //       td
      //     );
      //   }
      // },
      // {
      //   data: "nubis_version",
      //   className: "nubis_version",
      //   title: `${t("category.nubisVersion", {nubis: langConf.deviceCenter?.nubisText || "Nubis"})}`
      // },
      {
        data: "fecp_created_at",
        className: "datetime-cell",
        title: `${t({ defaultMessage: "创建时间" })}`,
        render: data => {
          return dayjs(data).format("YYYY-MM-DD HH:mm");
        }
      },
      {
        data: "fecp_activated_at",
        className: "datetime-cell",
        title: `${t({ defaultMessage: "激活时间" })}`,
        render: data => {
          return dayjs(data).format("YYYY-MM-DD HH:mm");
        }
      },
      {
        data: "latest_task.executed_at",
        className: "datetime-cell",
        title: `${t({ defaultMessage: "最后命令时间" })}`,
        render: data => {
          return dayjs(data).format("YYYY-MM-DD HH:mm");
        }
      },
      {
        data: "latest_task.status",
        className: "status",
        title: `${t({ defaultMessage: "最后执行状态" })}`,
        createdCell: (td, data, rowData) => {
          ReactRender(
            <TaskStatusBar
              status={data}
              message={
                !rowData.latest_task?.response
                  ? null
                  : rowData.latest_task.response
              }
              isOffline={rowData.online_offline_status !== "online"}
            />,
            td
          );
        }
      },
      {
        data: "last_updated_at",
        className: "datetime-cell",
        title: t({ defaultMessage: "{ora}最后更新时间" }, {ora: langConf.deviceCenter?.oraText || "Ora"}),
        render: data => {
          if (data) {
            return dayjs(data).format("YYYY-MM-DD HH:mm");
          }
          return "";
        }
      },
      {
        data: "last_updated_status",
        className: "status",
        title: `${t({ defaultMessage: "{ora}最后更新状态" }, {ora: langConf.deviceCenter?.oraText || "Ora"})}`,
        createdCell: (td, data) => {
          ReactRender(<TaskStatus status={data} />, td);
        }
      },
      {
        data: "heart_beated_at",
        className: "datetime-cell",
        title: `${t({ defaultMessage: "{ora}最后上线时间" }, {ora: langConf.deviceCenter?.oraText || "Ora"})}`,
        render: data => {
          if (data) {
            return dayjs(data).format("YYYY-MM-DD HH:mm");
          }
          return "";
        }
      }
    ];

    const [columns, setColumns] = useState(createColumns);

    const initTable = async () => {
      const {
        query,
        filterByMode,
        searchValue,
        groupId,
        tagIds,
        deviceStatus,
        nubisVersion,
        osType,
        kioskMode,
        nubisCast,
        latestTaskStatus,
        lastUpdatedStatus
      } = paramsRef.current;

      const { page, length } = lastGroupQueryPageInfoRef.current;

      const company_id = await localforage.getItem("currentCompanyId");

      const options = {
        serverSide: true,
        // order: [[3,'asc']],
        order: lastGroupQueryOrderInfoRef.current,
        deferRender: true,
        ordering: true,
        displayStart: page * length,
        pageLength: length,
        initComplete: function (settings, json, api) {
          api.on("click", ".icon-setting", () => {
            setColumnsManagerModalOpen(true);
          });
          queryParams.current = api.ajax.params();
        },
        ajax: {
          url: `${url}/api/v2/devices/dataTables`,
          type: "GET",
          data: {
            company_id,
            group_ids: filterByMode
              ? query.get("groupIds")?.split(",")
              : groupId,
            tag_ids: tagIds,
            searching: searchValue,
            search_type: query.get("searchType") || undefined,
            full_search:
              !!query.get("full_search") || !!query.get("hasSubCompanies")
                ? 1
                : undefined,
            nubis_version: nubisVersion,
            device_status: deviceStatus,
            ora_version: query.get("ora_version") || undefined,
            os_type: query.get("os_type") || osType || undefined,
            kiosk_mode: kioskMode ?? -1,
            additional_type:
              nubisCast === "" || nubisCast === undefined || nubisCast === null
                ? undefined
                : isNaN(Number(nubisCast))
                ? nubisCast
                : Number(nubisCast),
            latest_task_status: latestTaskStatus || undefined,
            last_updated_status: lastUpdatedStatus || undefined,
            devices_offline_days:
              query.get("devices_offline_days") || undefined,
            task_type: query.get("task_type") || undefined,
            task_status: query.get("task_status") || undefined,
            realtime_type: query.get("realtime_type") || undefined,
            realtime_range: query.get("realtime_range") || undefined,
            device_model: query.get("device_model") || undefined,
            device_group: query.get("device_group") || undefined
          }
        },
        columns: [
          {
            data: "id",
            name: "id",
            searchable: false,
            orderable: false,
            type: "checkbox"
          },
          {
            name: "orderNo",
            title: t({ defaultMessage: "序号" })
          }
        ]
          .concat(columns)
          .concat({
            data: null,
            className: "setting-cell",
            searchable: false,
            orderable: false,
            title: `<span class="icon-setting ${classes.setting}"><img width="16" height="16" src="${iconSetting}" /></span>`,
            defaultContent: ""
          })
          .filter(v => v.data !== undefined)
      };
      setOptions(options);
      return Promise.resolve().then(() => tableRef.current.reload());
    };

    const handleExport = async () => {
      // const token = await localforage.getItem("token");
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      getDevicesListExcel({ ...queryParams.current, timeZone }).then(res => {
        toast.success(res.message);
      });
    };

    const handleColumnsClose = () => {
      setColumnsManagerModalOpen(false);
    };

    const handleColumnsConfirm = async list => {
      await updateDeviceListFieldsApi({
        deviceListFields: JSON.stringify(
          list.map(item => ({
            field: item.data,
            show: item.visible,
            exportable: item.exportable
          }))
        )
      });
      setLastGroupQueryOrderInfo(defaultOrderInfo);
      setColumns(list);
      setColumnsManagerModalOpen(false);
    };

    const getDefaultColumns = () => {
      return createColumns().map(item => ({
        ...item,
        visible: item.visible === false ? false : true,
        exportable: true
      }));
    };

    const getColumnsConfig = async columns => {
      const deviceListFields = await getDeviceListFieldsApi();
      const newColumns = deviceListFields.map(item => {
        const relaColumn = columns.find(column => column.data === item.field);
        return {
          ...relaColumn,
          visible: item.show ?? true,
          exportable: item.exportable ?? true
        };
      });
      setColumns(newColumns);
      customFieldsLoaded.current = true;
    };

    useImperativeHandle(ref, () => ({
      api: () => tableRef.current?.api(),
      selectAll: state => {
        tableRef.current.selectAll(state);
      },
      getAll: () => {
        return tableRef.current.getAll();
      },
      getSelected: () => {
        return tableRef.current.getSelected();
      },
      getSelectedRows: () => {
        return tableRef.current.getSelectedRows();
      },
      load: () => {
        paramsRef.current = getSearchParams();
        if (!customFieldsLoaded.current) {
          return getColumnsConfig(columns);
        }
        setLastGroupQueryPageInfo(prev => ({
          ...defaultPageInfo,
          length: prev.length
        }));
        setLastGroupQueryOrderInfo(defaultOrderInfo);
        return initTable();
      },
      reload: resetPage => {
        paramsRef.current = getSearchParams();
        if (resetPage) {
          setLastGroupQueryPageInfo(prev => ({
            ...defaultPageInfo,
            length: prev.length
          }));
        }
        return initTable();
      },
      export: handleExport
    }));

    useUpdateEffect(() => {
      getColumnsConfig(createColumns());
    }, [userLanguage, langConf]);

    useUpdateEffect(() => {
      initTable();
    }, [columns]);

    return (
      <>
        <DataTable
          ref={tableRef}
          options={options}
          className={className}
          style={style}
          footer={footer}
          scrollable
          rerenderOnLanguageChange={false}
          showCheckAll={showCheckAll}
          checkAllDisabled={checkAllDisabled}
          onCheckAll={onCheckAll}
          onOrder={handleOrder}
          onLoaded={onLoaded}
          onPageChange={handlePageLengthChange}
          onLengthChange={handlePageLengthChange}
        >
          {children}
        </DataTable>
        <DeviceTableColumnsManagerModal
          list={columns}
          open={columnsManagerModalOpen}
          getDefaultColumns={getDefaultColumns}
          onClose={handleColumnsClose}
          onConfirm={handleColumnsConfirm}
        />
      </>
    );
  }
);

export default React.memo(DevicesTable);
